"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircuitBreakers = function CircuitBreakers(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: color
  }));
};

CircuitBreakers.defaultProps = {
  color: "grey",
  width: "40px",
  height: "45px"
};
var _default = CircuitBreakers;
exports.default = _default;